import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css'; // Commente pour l'instant si non existant
import App from './App';
import { AuthProvider } from './contexts/AuthContext'; // Importer AuthProvider
import ReduxProvider from './providers/ReduxProvider'; // Importer ReduxProvider
import ReactQueryProvider from './providers/ReactQueryProvider'; // Importer React Query Provider
import NotificationProvider from './providers/NotificationProvider'; // Importer Notification Provider
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ReduxProvider> { /* Envelopper avec Redux Provider */ }
      <ReactQueryProvider> { /* Envelopper avec React Query Provider */ }
        <NotificationProvider> { /* Envelopper avec Notification Provider */ }
          <AuthProvider> { /* Envelopper App avec AuthProvider */ }
            <App />
          </AuthProvider>
        </NotificationProvider>
      </ReactQueryProvider>
    </ReduxProvider>
  </React.StrictMode>
);

// reportWebVitals();
